import { CuratedDealFeesDetailsSection } from '../../../DealDetails/sections/CuratedDealFeesSection/CuratedDealFeesDetailsSection.tsx';
import { useDealContext } from '../../../utils/context/DealContext.tsx';

export const CuratedDealFeesFormSectionReadOnly = () => {
  const { useDealFormSelector } = useDealContext();
  const {
    dealForm: { currentDeal },
  } = useDealFormSelector();

  return currentDeal && <CuratedDealFeesDetailsSection deal={currentDeal} />;
};
